// Shared tooltip bodies for the member Rôle / Accès dropdowns. Used by
// both the member edit modal (MemberModal) and the invitation modal
// (AddMemberModal) so the explanations stay in sync.

export const MemberRoleHelpContent = () => (
  <div className="flex flex-col gap-1">
    <div className="mb-1">
      Le rôle = la fonction du membre. Il détermine le poste qu'il peut occuper
      dans l'équipe d'un projet et certains comportements automatiques.
    </div>
    <div>
      • <b>Administrateur</b> — réservé aux niveaux d'accès Manager et
      Propriétaire. N'est pas assigné aux postes d'équipe d'un projet (rôle
      organisationnel uniquement).
    </div>
    <div>
      • <b>Conducteur</b> — assignable au poste « Conducteur ». Signe les
      comptes-rendus de chantier. Exposé comme contact email côté client.
    </div>
    <div>
      • <b>Commercial</b> — assignable au poste « Commercial ». Exposé comme
      contact email côté client.
    </div>
    <div>• <b>SAV</b> — assignable au poste « SAV ».</div>
    <div>
      • <b>Comptabilité</b> — assignable au poste « Comptabilité ». Reçoit en
      copie les emails de facturation. Exposé comme contact email côté client.
    </div>
    <div className="mt-1">
      • <b>Dessinateur</b> — assignable au poste « Dessinateur ». Lecture seule
      sur les étapes (ne peut pas valider de point de contrôle). Pas d'accès
      aux écrans Artisans ni Facturation. Masqué par défaut côté client, mais
      peut être rendu visible projet par projet via l'œil dans l'équipe.
    </div>
    <div className="mt-1 text-neutral-300 italic">
      Visibilité par défaut côté client : un membre ajouté à l'équipe est rendu
      visible automatiquement, sauf s'il est Dessinateur ou s'il a un niveau
      d'accès Manager / Propriétaire (ces derniers restent masqués par défaut,
      mais peuvent être activés à la main).
    </div>
  </div>
);

export const MemberAccessHelpContent = () => (
  <div className="flex flex-col gap-1">
    <div className="mb-1">
      Le niveau d'accès = ce que le membre peut voir et modifier dans
      l'organisation.
    </div>
    <div>
      • <b>Propriétaire</b> — tous les droits, ne peut pas être supprimé.
      Voit tout.
    </div>
    <div>
      • <b>Manager</b> — gère équipe, projets, facturation, paramètres.
      Voit tout.
    </div>
    <div>
      • <b>Membre</b> — voit uniquement ses projets (assignés ou dont il est
      client). L'option « Accès à tous les projets » ci-dessous lève cette
      restriction.
    </div>
    <div>
      • <b>Invité</b> — accès client en lecture seule.
    </div>
    <div className="mt-1 text-neutral-300 italic">
      L'accès se combine avec le « Rôle » à gauche.
    </div>
  </div>
);
